import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Bounce, Circ, Elastic, Expo, Linear, Sine, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch8_p05 } from "../../../layouts/ch8_p05/ch8_p05";

export class Chapter8Page5 extends AbstractStoryState implements ReturnType<typeof ch8_p05> {

    readonly bgContainer = this.addChild(new PIXI.Container());
    readonly bg = list(()=>this.bgContainer.addChildAt(new SceneSprite(), 0));

    readonly mgContainer = this.addChild(new PIXI.Container());
    readonly mg = list(()=>this.mgContainer.addChildAt(new SceneSprite(), 0));

    readonly waterContainer = this.addChild(new PIXI.Container());
    readonly water = list(()=>this.waterContainer.addChild(new SceneSprite()));
    readonly holly = this.addChild(new SceneSpine("holly-profile"));

    readonly treeBack = this.mgContainer.addChild(new SceneSprite());
    readonly lamb = this.mgContainer.addChild(new SceneSprite());
    readonly treeFront = this.mgContainer.addChild(new SceneSprite());

    protected lambTimeline?: TimelineMax;
    protected scrollTimeline?: TimelineLite;

    protected scrollPercentage: number = 0;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch8_p05.call(this);

        this.holly.playAnimation("row-boat");
        this.holly.update(0);
        this.holly.scale.x *= -1; // face right
        this.holly.position.y += 60; // eyeballed

        this.lambTimeline = new TimelineMax();
        this.lambTimeline.fromTo(this.lamb, 2,
            {pixi: {angle: -45}},
            {pixi: {angle: 45}, ease: Sine.easeInOut},
        );
        this.lambTimeline.fromTo(this.lamb, 2,
            {pixi: {angle: 45}},
            {pixi: {angle: -45}, ease: Sine.easeInOut},
        );
        this.lambTimeline.repeat(-1).yoyo(true);

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
        this.holly.update(pDeltaTime);
        this.scroll(this.scrollPercentage);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this.scroll(this.scrollPercentage);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public destroy() {
        super.destroy();
        this.lambTimeline?.kill();
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();

        this.scrollTimeline = new TimelineLite();
        const duration = 24;
        // walk 33% then pause
        this.scrollTimeline.to(this, duration, { scrollPercentage: 1, ease: Linear.easeNone });
        this.scrollTimeline.call(()=>{
            this.scrollTimeline?.timeScale(1);
        }, undefined, undefined, "+=0");
        this.scrollTimeline.call(()=>{
            this.gotoNextState({transition: "fade"});
        }, undefined, undefined, "+=1.5");
        this.scrollTimeline.timeScale(0);

        this.holly.interactive = true;
        this.holly.accessible = true;
        this.holly.buttonMode = true;
        this.holly.addListener(HLF.Input.Events.POINTER_TAP, ()=>{
            this.scrollTimeline?.timeScale(this.scrollTimeline?.timeScale() + 0.1);
        });
    }

    protected scroll(percentage: number) {
        this.bgContainer.x = percentage * (1664 - this.bgContainer.width);
        this.mgContainer.x = percentage * (1664 - this.mgContainer.width);
        this.waterContainer.x = percentage * (1664 - this.waterContainer.width);
    }
}